// extracted by mini-css-extract-plugin
module.exports = {"badges":"badges-module--badges--3oVko","badgeCol":"badges-module--badge-col--12Ptr","badgeImage":"badges-module--badge-image--1tO4l"};